<template>
    <div class="board" :data-color="color" :data-line-width="lineWidth" :data-mode="mode">
        <canvas ref="canvas" id="canvas"
                :data-oleft="offsetLeft"
                :data-otop="offsetTop"
                @mousemove="add($event)"
                @mousedown="mouseDown();add($event, true)"
                @mouseup="mouseUp();commit();"
                x_mouseout="isMouseDown = false; commit();"/>
        <canvas ref="background" id="background-canvas"/>
        {{tempTempBuffer
            .map(function(p){
                return "[X:" + p.x + ",Y:" + p.y + "]";
            })
            .join(",")}}
    </div>
</template>
<style scoped>
.board{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    opacity: 1;
    width:100%;
    height: 100vh
}
.board canvas#canvas{
    z-index:1;
}
.board canvas{
    width:100%;
    position:absolute;
    top: 0;
    left:0;

    margin: 0;
    top: 50%;
    transform: translateY(-50%);
}
/* .board .menu{
    position:absolute;
    z-index: 2;
}
.board .menu,
.board .menu ul{
    list-style-type: none;
    margin:0;
    padding:0;
}
.board .menu,
.board .menu ul{
    display:flex;
}
.board .menu{
    flex-direction: column;
    text-align:left;
}
.board .menu ul li{
    width:32px;
    display:block;
}
.board .menu ul li a{
    background:black;
    width:32px;
    height:32px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.board .color{
    display: block;
    width:32px;
    height:32px;
}
.board .size{
    display: block;
    background: #ffffff;
    border-radius:50%;
} */
</style>
<script>
import _ from "lodash"
export default {
    mounted(){this.detect();},
    beforeDestroy(){},
    data(){
        return {
            ctx:            null,
            bctx:           null,
            isMouseDown:    false,
            initialized:    false,
            prevX:          0,
            prevY:          0,
            currX:          0,
            currY:          0,
            w:              0,
            h:              0,
            offsetTop:      0,
            offsetLeft:     0,
            tempBuffer:     [],
            tempTempBuffer: [],
            points:         [],

            mode:           "draw",
            color:          "red",
            lineWidth:      12
        }
    },
    methods: {
        mouseDown: function(){
            this.detect();
            this.isMouseDown = true;
            this.$emit("startDrawing");
        },
        mouseUp: function(){
            this.isMouseDown = false;
            this.$emit("stopDrawing");
        },
        save: function(){
            var nc = document.createElement("canvas");
            var nctx = nc.getContext('2d');
            var canvas = this.$refs.canvas;
            var background = this.$refs.background;
            var w = 1920; //canvas.width;
            var h = (1920/canvas.width) * canvas.height;
            nc.width = w;
            nc.height = h;
            nctx.drawImage(background, 0, 0, w, h);
            nctx.drawImage(canvas, 0, 0, w, h);
            var link = document.createElement("A");
            link.download = 'image.jpg';
            link.href = nc.toDataURL("image/jpeg", 0.5)
            link.click();
            return link.href;
        },
        clear: function(resetAll){
            this.ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
            if(resetAll){
                this.bctx.clearRect(0, 0, this.$refs.background.width, this.$refs.background.height);
                this.points.splice(0);
                this.tempBuffer.splice(0);
            }
        },
        undo: function(){
            var ps = this.points.filter(function(x){
                return x.enabled;
            })
            if(ps.length>0){
                this.clear()
                ps[ps.length - 1].enabled = false;
                this.draw();
            }
        },
        redo: function(){
            var ps = this.points.filter(function(x){
                return !x.enabled;
            })
            if(ps.length>0){
                this.clear()
                ps[0].enabled = true;
                this.draw();
            }
        },
        detect: function(){
            window.canvas = this;
            var self = this;
            var _computeOffsets = function(){
                var element = self.$refs.canvas;  
                var bg      = self.$refs.background;
                if(!element || !bg){
                    return setTimeout(_computeOffsets, 100);
                }
                self.ctx = element.getContext('2d');
                self.bctx = bg.getContext('2d');
                self.w = element.width;
                self.h = element.height;
                self.offsetTop  = 0;
                self.offsetLeft = 0;
                do {
                    self.offsetTop  += element.getBoundingClientRect().top  || 0;
                    self.offsetLeft += element.offsetLeft || 0;
                    element = element.offsetParent || element.parentElement;
                } while(element);
            }
            _computeOffsets();
        },
        init: function(w,h){
            if(isNaN(w)) return self.$hisport.options.logger.error("Invalid width", w);
            if(isNaN(h)) return self.$hisport.options.logger.error("Invalid height", h);
            this.$refs.background.width     = w;
            this.$refs.background.height    = h;
            this.$refs.canvas.width         = w;
            this.$refs.canvas.height        = h;
            this.initialized = true;
            this.detect();
        },
        getCurrentFrameAsImage: function(source,sx,sy,sWidth,sHeight,dx,dy,dWidth,dHeight){
            var self = this;
            return new Promise(function(resolve, reject){
                if(!self.initialized) {
                    self.$hisport.options.logger.error("Canvas Board is not initialized yet");
                    return reject("Canvas Board is not initialized yet");
                }
                // setTimeout(function(){
                    // self.bctx.drawImage(source, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
                    // var img = self.$refs.background.toDataURL();
                    // resolve(img);
                    // var img = document.createElement("img");
                    var ctx = self.$refs.background.getContext("2d");
                    ctx.drawImage(source,sx,sy,sWidth,sHeight,dx,dy,dWidth,dHeight);
                    var data = self.$refs.background.toDataURL();
                    resolve(data);
                    self.$hisport.options.logger.log("Image exported from", source, "with datas", {source: {sx,sy,sWidth,sHeight}, destination: {dx,dy,dWidth,dHeight}});
                    self.$hisport.options.logger.image(data);
                    // img.src = self.$refs.background.toDataURL();
                    // document.body.appendChild(img);
                    // resolve(img.src);
                // }, 2000)
            })
        },
        draw: _.throttle(function() {
            this.clear();
            var self = this;
            var _draw = function(p){
                var x,y,dx,dy;
                self.ctx.beginPath();
                self.ctx.fillStyle = p.color;
                self.ctx.strokeStyle = p.color;
                self.ctx.lineWidth = p.lineWidth;
                switch(p.mode){
                    case "draw":{
                        self.ctx.moveTo(p.px, p.py);
                        self.ctx.lineTo(p.tx, p.ty);
                        self.ctx.fillRect(p.tx, p.ty, p.lineWidth, p.lineWidth);
                        //this.ctx.stroke();
                        //self.ctx.closePath();
                        break;
                    }
                    case "rectangle":{
                        x = p.px; //(p.tx - p.px > 0)?p.px:p.tx;
                        y = p.py; //(p.ty - p.py > 0)?p.py:p.ty;
                        dx = (p.tx - p.px);
                        dy = (p.ty - p.py);
                        self.ctx.rect(x, y, dx, dy);
                        self.ctx.stroke();
                        break;
                    }
                    case "circle":{
                        x = p.px; //(p.tx - p.px > 0)?p.px:p.tx;
                        y = p.py; //(p.ty - p.py > 0)?p.py:p.ty;
                        dx = Math.abs(p.tx - p.px)/2;
                        dy = Math.abs(p.ty - p.py)/2;
                        self.ctx.ellipse(x, y, dx, dy, Math.PI * 2, 0, Math.PI * 2);
                        self.ctx.stroke();
                        break;
                    }
                }
            }
            this.points.filter(function(x){
                return x.enabled;
            }).forEach(function(b){
                b.buffer.forEach(_draw);
            });
            this.tempBuffer.forEach(_draw);
        },50, {leading: true, trailing: true}),
        _add: function(e){
            var ratio   = this.$refs.canvas.width / this.$refs.canvas.offsetWidth;
            var x       = (e.clientX - this.offsetLeft) * ratio;
            var y       = (e.clientY - this.offsetTop) * ratio;
            if( x == this.currX && y == this.currY )
                return this.$hisport.options.logger.debug("Point skipped");
            this.prevX  = this.currX;
            this.prevY  = this.currY;
            this.currX  = x;
            this.currY  = y;
            this.points = this.points.filter(function(x){ return x.enabled; })
            switch(this.mode){
                case "draw": {
                    var action = {
                        px: this.prevX,
                        py: this.prevY,
                        tx: this.currX,
                        ty: this.currY,
                        lineWidth: this.lineWidth,
                        color: this.color,
                        mode: this.mode
                    }
                    this.tempBuffer.push(action);
                    break;
                }
                case "circle":
                case "rectangle": {
                    if(this.tempBuffer.length == 0){
                        this.tempBuffer.push({
                            px: this.currX,
                            py: this.currY,
                            tx: this.currX,
                            ty: this.currY,
                            lineWidth: this.lineWidth,
                            color: this.color,
                            mode: this.mode
                        });
                    }else{
                        this.tempBuffer[0].tx = this.currX;
                        this.tempBuffer[0].ty = this.currY;
                    }
                    break;
                }
            }
            this.draw();
        },
        _do: _.throttle(function(){
            var e = this.tempTempBuffer.shift();
            if(!e) return;
            do{
                this._add(e);
                e = this.tempTempBuffer.shift();
            }while(e);
        }, 50, {leading: true, trailing: true}),
        add: function (e) {
            if(!this.isMouseDown)
                return;
            this.tempTempBuffer.push(e);
            this._do();
        },
        commit: function(){
            this._do()
            if(this.tempBuffer.length>0){
                this.points.push({
                    id: Date.now(),
                    enabled: true,
                    buffer: this.tempBuffer.splice(0)
                });
            }
        },
        changeColor: function(color){
            this.color = color;
        },
        changeLineWidth: function(lw){
            this.lineWidth = lw;
        },
        changeMode: function(mode){
            this.mode = mode;
        }
    }
}
</script>